import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './app/App';

const container = document.getElementById('root');
if (!container) throw new Error('No se encontró #root en el DOM');

const root = createRoot(container);
root.render(<App />);

const loading = document.getElementById('app-loading');
if (loading) loading.remove();
